import React, { useRef, useLayoutEffect } from 'react';

/**
 * 企业微信 Open Data 组件
 * 用于显示企业微信通讯录中的用户名称、部门名称等信息
 */
const WWOpenData = ({ type, openid, corpid }) => {
    const ref = useRef(null);

    useLayoutEffect(() => {
        if (window.WWOpenData && ref.current) {
            try {
                window.WWOpenData.bind(ref.current);
            } catch (error) {
                console.error('WWOpenData bind failed:', error);
            }
        }
    }, [type, openid, corpid]);

    return (
        <span ref={ref}>
            <ww-open-data type={type} openid={openid} corpid={corpid} />
        </span>
    );
};

export default WWOpenData;
